<template>
  <a-modal class="date-modal-css" v-model="showRefreshModal" title="刷新" width="450px" :maskClosable="false" :closable="true" :destroyOnClose="true">
    <a-form layout="inline" :labelCol="{ style: { width: '70px' } }">
      <a-form-item label="刷新时间">
        <a-date-picker v-model="calculateDate" valueFormat="YYYY-MM-DD" style="width: 180%" :disabled-date="disabledEndDate" />
      </a-form-item>
    </a-form>
    <template #footer>
      <div class="footer-btn-wrapper">
        <a-button @click="onCancel">取消</a-button>
        <a-button type="primary" :loading="loading" @click="onSubmit">确定</a-button>
      </div>
    </template>
  </a-modal>
</template>

<script>
import {
  apiInvCorePerformanceReportRefresh
} from '@/api/report/core-indicators-report'
export default {
  name: 'RefreshModal',
  data () {
    return {
      loading: false,
      showRefreshModal: false,
      calculateDate: '' // 刷新时间
    }
  },
  methods: {
    onSubmit() {
      this.loading = true
      apiInvCorePerformanceReportRefresh({ calculateDate: this.calculateDate }).then(res => {
        if (res?.code === 200) {
          this.$message.success('刷新成功')
          this.$emit('refresh')
          this.showRefreshModal = false
        }
      }).finally(() => {
        this.loading = false
      })
    },
    onCancel() {
      this.showRefreshModal = false
    },
    show() {
      this.loading = false
      this.calculateDate = this.$moment(new Date()).format('YYYY-MM-DD')
      this.showRefreshModal = true
    },
    // 只能选历史日期
    disabledEndDate (date) {
      return date && date.valueOf() > Date.now();
    }
  }
}
</script>

<style scoped>

</style>
